module.exports = __webpack_public_path__ + "static/media/resetLightIcon.34907976.svg";